import { parsePhoneNumber } from "libphonenumber-js/max";
import { getCountryCallingCode } from "libphonenumber-js/max";

export const normalizePhone = (raw, defaultCountry) => {
  if (!raw) return raw;
  const cleaned = String(raw).replace(/\s+/g, "");
  if (cleaned.startsWith("+")) return cleaned;
  try {
    const parsed = parsePhoneNumber(cleaned, defaultCountry);
    return parsed?.isValid() ? parsed.number : cleaned;
  } catch {
    return cleaned;
  }
};

export const isValidMobile = (raw, defaultCountry) => {
  try {
    const parsed = parsePhoneNumber(normalizePhone(raw, defaultCountry));
    if (!parsed?.isValid()) return false;
    if (parsed.country === "IN") return /^[6-9]\d{9}$/.test(parsed.nationalNumber);
    const type = parsed.getType();
    return type === "MOBILE" || type === "FIXED_LINE_OR_MOBILE";
  } catch {
    return false;
  }
};

export function normalizePhoneForDisplay(rawValue, defaultCountry = "NL") {
  if (!rawValue) return rawValue;

  const trimmed = rawValue.trim();
  if (!trimmed) return rawValue;

  // Already has a country code — keep exactly as stored, don't reformat
  if (trimmed.startsWith("+")) {
    return trimmed;
  }

  // Old-style international prefix (00...) — just swap 00 for +
  if (trimmed.startsWith("00")) {
    return "+" + trimmed.slice(2);
  }

  // Legacy local format — prepend the country code, keep the rest untouched
  let callingCode;
  try {
    callingCode = getCountryCallingCode(defaultCountry);
  } catch {
    callingCode = "31";
  }

  if (trimmed.startsWith("0")) {
    return `+${callingCode}${trimmed.slice(1)}`;
  }

  // No recognizable prefix at all — just prepend the country code
  return `+${callingCode}${trimmed}`;
}